import { useState, useEffect } from 'react';
import { useNavigate, useLocation, NavLink } from 'react-router-dom';
import client from '../api/client';
import { useAuth } from '../context/AuthContext';
import PinResetModal from './PinResetModal';

export const NAV = [
  { to:'/',                      label:'Dashboard' },
  { to:'/tenants',               label:'Tenants' },
  { to:'/marketing',             label:'Marketing' },
  { to:'/marketing-wizard',      label:'New campaign (wizard)' },
  { to:'/engagement-leads',      label:'Engagement leads' },
  { to:'/databases',             label:'Databases' },
  { to:'/send-plans',            label:'Send plans' },
  { to:'/cancellation-requests', label:'Cancellation requests' },
  { to:'/staff',                 label:'Staff' },
  { to:'/plans',                 label:'Plans' },
  { to:'/api-keys',              label:'API keys' },
  { to:'/applications',          label:'Rep applications' },
  { to:'/network-partners',      label:'Network partners' },
  { to:'/commissions',           label:'Commissions' },
  { to:'/commission-settings',   label:'Commission settings' },
  { to:'/regions-areas',         label:'Regions and areas' },
  { to:'/rep-activity',          label:'Rep activity' },
  { to:'/audit-log',             label:'Audit log' },
];

const btn = { display:'flex', alignItems:'center', gap:6, padding:'7px 11px', background:'#fff', border:'1px solid #e2e2e2', borderRadius:8, cursor:'pointer', fontSize:13, color:'#444', whiteSpace:'nowrap' };

export default function TopBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, name, role } = useAuth();
  const [menu, setMenu] = useState(false);
  const [pin, setPin] = useState(false);
  const [pending, setPending] = useState(0);

  useEffect(() => {
    const f = () => client.get('/admin/cancellation-requests/pending-count')
      .then(r => setPending(r.data.count || 0)).catch(() => {});
    f();
    const t = setInterval(f, 30000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => { setMenu(false); }, [location.pathname]);

  const current = NAV.find(n => n.to === location.pathname);
  const title = current ? current.label : 'Admin';

  return (
    <>
      <header style={{ position:'sticky', top:0, zIndex:900, background:'#fff', borderBottom:'1px solid #eee', padding:'10px 14px', display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
        <button style={btn} onClick={() => setMenu(m => !m)}>&#9776; Menu</button>
        <button style={btn} onClick={() => navigate(-1)}>&#8592;</button>
        <button style={btn} onClick={() => navigate('/')}>Dashboard</button>
        <button style={btn} onClick={() => window.location.reload()}>&#8635;</button>
        <div style={{ flex:1, minWidth:120, textAlign:'center' }}>
          <div style={{ fontSize:16, fontWeight:700, color:'#111' }}>OurEsign</div>
          <div style={{ fontSize:10, letterSpacing:1.2, color:'#999', textTransform:'uppercase' }}>{title}</div>
        </div>
        <button style={{...btn, position:'relative'}} onClick={() => navigate('/cancellation-requests')}>
          &#128276;
          {pending > 0 && <span style={{ position:'absolute', top:-5, right:-5, background:'#c0392b', color:'#fff', borderRadius:10, padding:'1px 6px', fontSize:10, fontWeight:700 }}>{pending}</span>}
        </button>
        <button style={btn} onClick={() => setMenu(m => !m)} title={role}>
          <span style={{ width:24, height:24, background:'#1a5cff', color:'#fff', borderRadius:6, display:'inline-flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:700 }}>{name ? name[0].toUpperCase() : '?'}</span>
        </button>
      </header>

      {menu && (
        <>
        <div onClick={() => setMenu(false)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.25)', zIndex:999 }} />
        <div style={{ position:'fixed', top:0, left:0, bottom:0, width:260, background:'#fafafa', borderRight:'1px solid #eee', padding:'14px 12px', zIndex:1000, overflowY:'auto', boxShadow:'2px 0 14px rgba(0,0,0,0.10)' }}>{/* NAV_LEFTPANEL_v2 */}
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
            <span style={{ fontSize:14, fontWeight:700, color:'#111' }}>Menu</span>
            <button style={btn} onClick={() => setMenu(false)}>&#10005;</button>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            {NAV.map((n, i) => (
              <NavLink key={n.to} to={n.to} end={n.to === '/'}
                style={({ isActive }) => ({ padding:'9px 12px', borderRadius:8, textDecoration:'none', fontSize:14,
                  color: isActive ? '#1a5cff' : '#444', background: isActive ? '#eef3ff' : '#fff', border:'1px solid #eee' })}>
                {`${i + 1}. ${n.label}`}
              </NavLink>
            ))}
          </div>
          <div style={{ display:'flex', gap:8, marginTop:12, flexWrap:'wrap' }}>
            <div style={{ flex:1, minWidth:140, fontSize:13, color:'#666', alignSelf:'center' }}>{name} &middot; {(role||'').replace(/_/g,' ')}</div>
            <button style={btn} onClick={() => { setPin(true); setMenu(false); }}>Reset my PIN</button>
            <button style={{...btn, color:'#c0392b'}} onClick={() => { logout(); navigate('/login'); }}>Sign out</button>
          </div>
        </div>
        </>
      )}

      {pin && <PinResetModal onClose={() => setPin(false)} />}
    </>
  );
}
